import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (localStorage.getItem('adminToken')) setIsAuthenticated(true);
    setLoading(false);
  }, []);
  const login = async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('adminToken', data.token);
    setIsAuthenticated(true);
  };
  const logout = () => { localStorage.removeItem('adminToken'); setIsAuthenticated(false); };
  return <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
